<template>
    <header class="header df-header">
        <nav class="navbar navbar-inverse">
            <div class="header-container">
                <div class="navbar-header">
                    <a class="navbar-brand" @click="navTo('Smart')">
                        <img :src="logo" alt="智能小程序" style="width: 121px; height: 21px;">
                    </a>
                    <div class="navbar-brand" style="padding-top: 20px;">
                        <span></span>
                    </div>
                    <a class="navbar-brand" @click="navTo('openSource')">
                        <img src="https://mbs1.bdstatic.com/static/smartprogram-opensource/img/logo_opensource.1da5029.png" alt="开源联盟"
                            style="width: 69px; height: 17px; margin-top: 2px;">
                    </a>
                </div>


                <div id="navbar" class="collapse navbar-collapse">
                    <img src="../assets/images/header_list.png" class="navbar-right navbar-list">
                    <ul class="nav navbar-nav navbar-right nav-user-info">
                        <!-- 文档链接 -->
                        <li class="navbar-right-link" @click="navTo('Docs')">
                            <a class="f-nav f-nav-right f-nav-right-link">开源文档</a>
                        </li>
                        <!-- 用户信息 -->
                        <li v-if="isLogin" class="logged df-nav-logged">
                            <div class="logged-wrapper list-item user-avatar-wrapper"
                                @mouseover="setIsShow(true)"
                                @mouseout="setIsShow(false)">
                                <span class="avatar-a-export">
                                    <img :src="avatar" class="forum-avatar"
                                        alt-title="用户头像">
                                        <span v-if="isLogin" class="icon-arrow"></span>
                                </span>
                                <div v-show="loggedPopClass" class="user-menu show-pop">
                                    <span class="icon-arrow-pop"></span>
                                    <ul>
                                        <li>{{userName}}</li>
                                        <li v-if="relationVirtualUserList.length" class="log-out" @click="clickSwitch">
                                            切换
                                        </li>
                                        <li class="log-out" @click="navToExit">退出</li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- 用户身份信息切换弹窗 -->
                <el-dialog
                    width="640px"
                    v-if="confirm && isLogin && relationVirtualUserList.length"
                    class="navbar-dialog"
                    title="请选择要切换的用户"
                    :visible.sync="confirm"
                >
                    <div class="navbar-dialog-container">
                        <div
                            v-for="item in relationVirtualUserList"
                            :key="item.userNo"
                            class="navbar-dialog-wrap"
                            @click="changeUser(item)"
                        >
                            <input
                                class="navbar-dialog-radio"
                                :checked="item.userNo === userNo"
                                type="radio"
                                name="changeAvatar"
                                id="type"
                            />
                            <div class="navbar-dialog-info">
                                <img class="navbar-dialog-info-avatar" :src="item.avatar">
                                <img v-if="item.isOfficial" class="navbar-dialog-info-icon" :src="verity">
                            </div>
                            <div class="navbar-dialog-user">
                                <div class="navbar-dialog-user-name">{{item.nickname}}</div>
                                <div class="navbar-dialog-user-discern">{{item.userNo}}</div>
                            </div>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </nav>
    </header>
</template>

<style lang="less">
    @import '../assets/less/components/header.less';
</style>

<script>
import {mapState, mapActions} from 'vuex';

export default {
    mounted() {
        this.$store.dispatch('getUserInfo');
    },
    computed: {
        ...mapState({
            isLogin: state => state.header.isLogin,
            logo: state => state.header.logo,
            forum: state => state.header.forum,
            // 开发者社区图片
            messageNum: state => state.header.messageNum,
            avatar: state => state.header.avatar,
            userName: state => state.header.userName,
            userNo: state => state.header.userNo,
            // 切换用户气泡框显示
            isShow: state => state.header.isShow,
            searchSource: state => state.header.searchSource[0],
            isOfficial: state => state.header.isOfficial,
            relationVirtualUserList: state => state.header.relationVirtualUserList || []
        }),
        loggedPopClass() {
            return this.isShow;
        }
    },
    data() {
        return {
            verity: require('@/assets/images/icon-official.png'),
            confirm: false
        };
    },
    methods: {
        ...mapActions([
            'navToPassport',
            'navToExit'
        ]),
        navTo(name) {
            this.$store.dispatch('navTo', name);
        },
        setIsShow(val) {
            this.$store.commit('setIsShow', val);
        },

        /**
         * 点击切换按钮时触发
         */
        clickSwitch() {
            this.confirm = true;
        },

        /**
         * 切换用户
         *
         * @param {Object} user 当前选择用户的信息
         */
        async changeUser(user) {
            this.confirm = false;
            document.cookie = `USER_NO=${user.userNo};path=/`;
            await this.$store.dispatch('getUserInfo');
            await this.$router.replace({name: 'home'});
            this.$store.commit('changeLoadingState', true);
            this.$store.dispatch('getMainList', {params: this.$route.params, query: this.$route.query})
                .then(() => {
                    this.$store.commit('changeLoadingState', false);
                });
        }
    }
};
</script>
